import React from "react";
import { VehicleReadings } from "../components/VehicleReadings";
import { FuelType } from "../useKeylessReturn";
import key_fuel_level_warning from "../../../../assets/images/keyless-return/warning_fuel_level.svg";

// Mensagem consoante o que divergiu do registo do veículo: combustível/carga, kms, ou ambos.
function getMismatchKey(fuelType, fuelDivergence, kmsDivergence) {
  const isElectric = fuelType === FuelType.ELECTRIC;

  if (fuelDivergence && kmsDivergence) {
    return isElectric ? "keylessReturnChargeKmsMismatch" : "keylessReturnFuelKmsMismatch";
  }

  if (kmsDivergence) {
    return "keylessReturnKmsMismatch";
  }

  return isElectric ? "keylessReturnChargeMismatch" : "keylessReturnFuelMismatch";
}

export default function ValidateFuelLevelAndKms({
  fuelType,
  fuelLevel,
  setFuelLevel,
  kms,
  setKms,
  fuelDivergence,
  kmsDivergence,
  t,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <img
        src={key_fuel_level_warning}
        alt="Key Dropoff"
        style={{
          maxWidth: "100%",
          marginBottom: "1rem",
        }}
      />

      <div style={{ margin: "1rem 0", lineHeight: "1.3" }}>
        <p style={{ fontSize: "1.4rem", margin: "0" }}>
          {t(getMismatchKey(fuelType, fuelDivergence, kmsDivergence))}
        </p>

        <p
          style={{
            color: "#ff8533",
            fontSize: "1.4rem",
            fontWeight: "600",
            margin: "0",
          }}
        >
          {t("keylessReturnFuelRegister")}
        </p>
      </div>

      <VehicleReadings
        fuelType={fuelType}
        fuelLevel={fuelLevel}
        setFuelLevel={setFuelLevel}
        kms={kms}
        setKms={setKms}
        t={t}
      />
    </div>
  );
}
